import type { IndicatorKey } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/IndicatorKey.ts";
import { useTranslation } from "react-i18next";

export default function useIndicatorLabelAndUnit(indic: IndicatorKey): {
  label: string;
  unit: string | undefined;
} {
  const { t, i18n } = useTranslation("humanResources");

  const i18nPrefix = `humanResources:timeManagement.analysis.indicators.${i18nIndicName(indic)}`;
  const label = t(`${i18nPrefix}.label`);
  const unitKey = `${i18nPrefix}.unit`;
  const unit = i18n.exists(unitKey) ? t(unitKey) : undefined;

  function i18nIndicName(indic: IndicatorKey): string {
    switch (indic) {
      case "workedTimeMinutes":
        return "workedTime";
      default:
        return indic;
    }
  }

  return { label, unit };
}
